import CaseStudy from "../../CaseStudy/CaseStudy";

class ContentCaseStudies {
  constructor(contentfulNode) {
    this.title = contentfulNode?.caseStudiesSectionTitle;
    this.featuredCaseStudies = contentfulNode?.featuredCaseStudies
      ? contentfulNode?.featuredCaseStudies.map(caseStudy => new CaseStudy(caseStudy))
      : null;
    this.type = 'CONTENT_CASE_STUDIES'
  }
}

export { ContentCaseStudies };
